import React from "react"

type Props = {
  isSidebarOpen: boolean
  compact: boolean
  /** Stacking context differs per layout (z-20 / z-30). */
  zIndexClass?: string
  /** The faint patterned backdrop behind the admin/manager/employee menus. */
  backdrop?: boolean
  children: React.ReactNode
}

const WIDTH_TRANSITION =
  "transition-[width] duration-300 ease-in-out motion-reduce:transition-none"

/**
 * The sidebar panel itself. Below md it is a drawer (`isSidebarOpen`); on md+
 * its width is `--sidenav-w`, which animates between 256px and the 64px icon
 * rail. Content is clipped horizontally so labels fade rather than wrap while
 * the width is in motion, and the scrollbar is hidden while compact so the
 * rail stays exactly 64px.
 */
const SideNavFrame = ({
  isSidebarOpen,
  compact,
  zIndexClass = "z-20",
  backdrop = false,
  children,
}: Props) => {
  const drawerWidth = !isSidebarOpen ? "w-0" : "w-[280px]"

  return (
    <div
      className={`custom__sidebar__scrollbar ${drawerWidth} ${
        compact ? "scrollbar-hide" : ""
      } pb-20 md:pb-0 fixed top-0 bottom-0 ${zIndexClass} md:left-0 md:w-[var(--sidenav-w)] shadow-lg h-[100dvh] bg-primary500 ${WIDTH_TRANSITION} overflow-y-auto overflow-x-hidden`}
    >
      {backdrop && (
        <div
          className={`${drawerWidth} fixed top-0 bottom-0 z-[1] md:left-0 md:w-[var(--sidenav-w)] h-[100dvh] opacity-30 bg-center bg-cover ${WIDTH_TRANSITION}`}
          style={{
            backgroundImage: `url(https://padefiles.blob.core.windows.net/images/8273822e-4938-498a-a110-8736d5b5ad21.png)`,
          }}
        />
      )}
      {children}
    </div>
  )
}

export default SideNavFrame
